var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "box view-nav-bar" }, [
      _c("div", { staticClass: "d-flex align-items-center w-100" }, [
        _c("div", { staticClass: "flex-grow-1" }, [
          _c("strong", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _vm.current && _vm.current.movix_id
            ? _c("span", { staticClass: "text-muted ml-2" }, [
                _vm._v(
                  "\n                    #" +
                    _vm._s(_vm.current.movix_id) +
                    "\n                "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.current && _vm.current.imdb_id
            ? _c(
                "a",
                {
                  staticClass: "ml-3",
                  attrs: {
                    href: `https://www.imdb.com/title/${_vm.current.imdb_id}/`,
                    target: "_blank",
                    rel: "noopener",
                  },
                },
                [
                  _vm._v(
                    "\n                    IMDb: " +
                      _vm._s(_vm.current.imdb_id) +
                      "\n                "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-outline-secondary mr-2",
                attrs: { to: "/history/" + _vm.movixId + "/month" },
              },
              [_vm._v("\n                    Per Month\n                ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                attrs: { variant: "primary", disabled: _vm.running },
                on: { click: _vm.onUpdate },
              },
              [
                _vm.running
                  ? _c("spinner-bars")
                  : _c("span", [_vm._v("Update")]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    !_vm.loaded
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("Loading…")]
          ),
        ])
      : !_vm.current
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [
              _vm._v("\n            Movie not found.\n            "),
              _c(
                "router-link",
                { staticClass: "ml-2", attrs: { to: "/history/search" } },
                [_vm._v("Back to search")]
              ),
            ],
            1
          ),
        ])
      : _c("div", [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "box" }, [
                _c(
                  "div",
                  { staticClass: "box-content" },
                  [
                    _c("heading", { attrs: { upper: "Metadata", border: "" } }),
                    _vm._v(" "),
                    _c("dl", { staticClass: "row mb-0" }, [
                      _c("dt", { staticClass: "col-5" }, [_vm._v("Year")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(_vm._s(_vm.current.year || "—")),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [_vm._v("Released")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(_vm._s(_vm.formatDate(_vm.current.released_at))),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [_vm._v("Genres")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(_vm._s(_vm.current.genre_list || "—")),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [_vm._v("Countries")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(_vm._s(_vm.current.countries || "—")),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [_vm._v("Movie tag")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(_vm._s(_vm.current.movie_tag || "—")),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [
                        _vm._v("First admissions"),
                      ]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatDate(_vm.current.first_admissions_at)
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [
                        _vm._v("Last admissions"),
                      ]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(_vm.current.last_admissions_at))
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "box" }, [
                _c(
                  "div",
                  { staticClass: "box-content" },
                  [
                    _c("heading", {
                      attrs: { upper: "Admissions", border: "" },
                    }),
                    _vm._v(" "),
                    _c("dl", { staticClass: "row mb-0" }, [
                      _c("dt", { staticClass: "col-5" }, [
                        _vm._v("Belgium total"),
                      ]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatInt(_vm.current.total_admissions_belgium)
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [
                        _vm._v("Brightfish total"),
                      ]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatInt(
                              _vm.current.total_admissions_brightfish
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [_vm._v("Papayas")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(_vm._s(_vm.formatInt(_vm.current.papayas))),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [_vm._v("Burn rate")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(
                          _vm._s(
                            _vm.current.burn_rate_weeks !== null
                              ? _vm.current.burn_rate_weeks + " weeks"
                              : "—"
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("heading", {
                      staticClass: "mt-3",
                      attrs: { upper: "Yearly Brightfish totals", border: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "lower",
                          fn: function () {
                            return [
                              _c(
                                "ul",
                                { staticClass: "list-unstyled mb-0" },
                                _vm._l(_vm.yearlyTotals, function (yt, idx) {
                                  return _c("li", { key: idx }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(yt.year || "—") +
                                        ": " +
                                        _vm._s(
                                          _vm.formatInt(
                                            yt.total_brightfish_admissions
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ])
                                }),
                                0
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "box" }, [
                _c(
                  "div",
                  { staticClass: "box-content" },
                  [
                    _c("heading", {
                      attrs: { upper: "Geography", border: "" },
                    }),
                    _vm._v(" "),
                    _c("dl", { staticClass: "row mb-0" }, [
                      _c("dt", { staticClass: "col-5" }, [_vm._v("North")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(_vm._s(_vm.pct(_vm.current.fraction_geo_north))),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [_vm._v("South")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(_vm._s(_vm.pct(_vm.current.fraction_geo_south))),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [_vm._v("Brussels")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(
                          _vm._s(_vm.pct(_vm.current.fraction_geo_brussels))
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "box" }, [
                _c(
                  "div",
                  { staticClass: "box-content" },
                  [
                    _c("heading", {
                      attrs: { upper: "Languages", border: "" },
                    }),
                    _vm._v(" "),
                    _c("dl", { staticClass: "row mb-0" }, [
                      _c("dt", { staticClass: "col-5" }, [_vm._v("NL")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(_vm._s(_vm.pct(_vm.current.fraction_lang_nl))),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [_vm._v("FR")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(_vm._s(_vm.pct(_vm.current.fraction_lang_fr))),
                      ]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "col-5" }, [_vm._v("VO")]),
                      _c("dd", { staticClass: "col-7" }, [
                        _vm._v(_vm._s(_vm.pct(_vm.current.fraction_lang_vo))),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c("heading", {
                  attrs: {
                    upper: "Per-site distribution (top 20)",
                    border: "",
                  },
                }),
                _vm._v(" "),
                !_vm.siteRows.length
                  ? _c("div", { staticClass: "text-muted pt-2" }, [
                      _vm._v("No per-site data."),
                    ])
                  : _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.siteRows, function (row) {
                          return _c("tr", { key: row.code }, [
                            _c("td", [_vm._v(_vm._s(row.code))]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(_vm.pct(row.fraction))),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", {
                                staticClass: "bg-secondary",
                                style: {
                                  width: Math.round(row.fraction * 100) + "%",
                                  height: "8px",
                                },
                              }),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c("div", { staticClass: "box-content text-muted" }, [
              _c("small", [
                _vm._v(
                  "\n                    Created: " +
                    _vm._s(_vm.formatDateTime(_vm.current.created_at)) +
                    "\n                     · \n                    Last compiled: " +
                    _vm._s(_vm.formatDateTime(_vm.current.updated_at)) +
                    "\n                "
                ),
              ]),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-120" }, [_vm._v("Theatre")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-100 text-right" }, [_vm._v("Share")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }